import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { StyleRoot } from 'radium';

import './Sidebar.scss';
import whiteLogo from '../../images/white_logo.svg';
import arrowUp from '../../images/arrow-up.svg';
import facebook from '../../images/fb_w.svg';
import instagram from '../../images/ig_w.svg';
import youtube from '../../images/yt_w.svg';
import SearchBar from '../SearchBar';
import useClickOutside from '../../utils/hooks/useClickOutside';
import { ANIMATIONS } from '../../utils/constants';
import AnimateHeight from 'react-animate-height';
import angleDown from '../../images/angle-down-white.svg';
// import expoLogo from '../../images/expo-logo.png';

const Submenu = ({ option }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="submenu">
      <button className="submenu__button" onClick={() => setOpen(!open)}>
        {option.text} <img className="submenu__angle" src={angleDown} alt="" />
      </button>
      <AnimateHeight height={open ? 'auto' : 0}>
        <ul className="submenu__options">
          {option?.subOptions?.map(subOption => (
            <li key={subOption.id} className="submenu__option">
              <a
                href={subOption.link}
                target="_blank"
                rel="noopener noreferrer"
                className="submenu__option-link"
              >
                {subOption.text}
              </a>
            </li>
          ))}
        </ul>
      </AnimateHeight>
    </div>
  );
};
const Sidebar = ({ onClose }) => {
  const sidebarContentRef = useRef();
  useClickOutside(sidebarContentRef, () => onClose());
  return (
    <div className="sidebar">
      <StyleRoot>
        <div
          className="sidebar__content"
          style={ANIMATIONS.slideInDown}
          ref={sidebarContentRef}
        >
          <div className="sidebar__header">
            <Link to="/">
              <img src={whiteLogo} alt="VEINSA" />
            </Link>
            <button onClick={onClose}>
              <img src={arrowUp} alt="Close" className="sidebar__close" />
            </button>
          </div>
          <div className="sidebar__searchbar">
            <SearchBar />
          </div>
          <ul className="sidebar__marcas">
            {/* UNCOMMENT FOR EXPO 2022 */}
            {/* <li className="sidebar__marca sidebar__link">
              <a href="https://expo.veinsamotors.com">
                <img src={expoLogo} alt="EXPOMOVIL" style={{ 'max-width': '20rem' }} />
              </a>
            </li> */}
            <li className="sidebar__marca">
              <Submenu
                option={{
                  text: 'MARCAS',
                  subOptions: [
                    {
                      id: 1,
                      text: 'MITSUBISHI',
                      link: 'http://mitsubishi.cr/',
                    },
                    {
                      id: 2,
                      text: 'SSANG YONG',
                      link: 'http://www.ssangyongcr.com/',
                    },
                    {
                      id: 3,
                      text: 'CITROEN',
                      link: 'http://www.citroencr.com/',
                    },
                    {
                      id: 4,
                      text: 'PEUGEOT',
                      link: 'http://www.peugeot.co.cr/',
                    },
                    {
                      id: 5,
                      text: 'MASERATI',
                      link: 'http://www.maserati.cr/',
                    },
                    {
                      id: 6,
                      text: 'GEELY',
                      link: 'http://www.geely.cr/',
                    },
                    // {
                    //   id: 7,
                    //   text: 'FUSO',
                    //   link: 'http://www.fuso.mitsubishi.cr/',
                    // },
                    {
                      id: 8,
                      text: 'JMC',
                      link: 'http://www.jmc.cr/',
                    },
                    {
                      id: 9,
                      text: 'MAHINDRA',
                      link: 'https://www.mahindra.cr/',
                    },
                    {
                      id: 10,
                      text: 'FARIZON',
                      link: 'https://www.farizon.cr/',
                    },
                    {
                      id: 11,
                      text: 'WELTMEISTER',
                      link: '/cotizador',
                    },
                  ],
                }}
              />
            </li>
            <li className="sidebar__marca">
              <a
                className="sidebar__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://veinsamotors.com/somos-veinsa/"
              >
                SOMOS VEINSA
              </a>
            </li>
            <li className="sidebar__marca">
              <a
                className="sidebar__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://veinsamotors.com/promociones/"
              >
                PROMOCIONES
              </a>
            </li>
            <li className="sidebar__marca">
              <Submenu
                option={{
                  text: 'SERVICIOS POST-VENTA',
                  subOptions: [
                    {
                      id: 1,
                      text: 'MANTENIMIENTO',
                      link: 'https://veinsamotors.com/mantenimiento/',
                    },
                    {
                      id: 2,
                      text: 'REPUESTOS',
                      link:
                        'https://veinsamotors.com/servicios/repuestos/carroceria/',
                    },
                  ],
                }}
              />
            </li>
            <li className="sidebar__marca">
              <a
                className="sidebar__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://veinsamotors.com/blog/"
              >
                BLOG
              </a>
            </li>
            <li className="sidebar__marca">
              <a
                className="sidebar__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://veinsamotors.com/contacto/"
              >
                CONTACTO
              </a>
            </li>
          </ul>
          <div className="sidebar__bottom-row">
            <p className="sidebar__bottom-p">Visita también nuestro sitio:</p>
            <a
              href="https://veinsausados.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="sidebar__button"
            >
              VEINSA USADOS
            </a>
          </div>
          <div className="sidebar__bottom-row">
            <div className="sidebar__flex">
              <p className="sidebar__bottom-p">Contáctanos</p>
              <a className="sidebar__phone" href="tel:+50640008000">
                (+506) 4000-8000
              </a>
            </div>
            <div className="sidebar__buttons">
              <a href="/" className="sidebar__button">
                COTIZAR AHORA
              </a>
              {/* <a href="/cotizador/test-drive" className="sidebar__button sidebar__button--white">TEST DRIVE</a> */}
            </div>
          </div>
          <div className="sidebar__social">
            <ul className="sidebar__social-list">
              <li className="sidebar__social-item">
                <a
                  href="https://www.facebook.com/VeinsaMotors/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sidebar__social-item-link"
                >
                  <img
                    className="sidebar__social-item-image"
                    src={facebook}
                    alt="Veinsa Facebook"
                  />
                </a>
              </li>
              <li className="sidebar__social-item">
                <a
                  href="https://www.instagram.com/veinsamotors/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sidebar__social-item-link"
                >
                  <img
                    className="sidebar__social-item-image"
                    src={instagram}
                    alt="Veinsa Instagram"
                  />
                </a>
              </li>
              <li className="sidebar__social-item">
                <a
                  href="https://www.youtube.com/channel/UC_gg688X_DEaHnT_yg73xSw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sidebar__social-item-link"
                >
                  <img
                    className="sidebar__social-item-image"
                    src={youtube}
                    alt="Veinsa Youtube"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </StyleRoot>
    </div>
  );
};

export default Sidebar;
